var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('column-graph',{staticClass:"mt-3",attrs:{"title":"","type":"small","data":_vm.items,"options":_vm.options,"no-results-title":_vm.$t('noResults'),"style-text-node":_vm.styleTextNode}})}
var staticRenderFns = []

export { render, staticRenderFns }